import { useAuthQuery } from 'app/api_v2/auth/queries';
import { isAgency } from 'app/helpers/userRoles';
import React from 'react';
import { Navigate } from 'react-router-dom';

interface HasToBeAgencyGuardProps {
  children: React.ReactNode;
}

export const HasToBeAgencyGuard = (props: HasToBeAgencyGuardProps) => {
  const { children } = props;

  const { isSuccess, data } = useAuthQuery();

  if (isSuccess && !data) {
    console.log('User is not logged in, redirecting to login page');
    return <Navigate to={'/auth/login'} />;
  }

  if (isSuccess && data && !isAgency(data)) {
    console.log('User is not an agency, redirecting to dashboard');
    return <Navigate to={'/dashboard'} />;
  }

  if (isSuccess) {
    return <>{children}</>;
  }
  return null;
};

export default HasToBeAgencyGuard;
